export enum ChartOfAccountId {
  Billy = 'billy',
  BillyWorld = 'billy_world',
  France = 'france',
  Germany = 'germany',
  Manual = 'manual',
  MenetoEmv = 'meneto_emv',
  MenetoSelskab = 'meneto_selskab',
  Netherlands = 'netherlands',
}
